import { createContext, useReducer, useContext } from 'react'
import { IApiAuthResponse } from '../constants/api-interfaces.js';


const initialState: IApiAuthResponse | null = null

// Actions
interface setAuth { type: 'setAuth'; payload: IApiAuthResponse | null } // For first load of user

type Action = setAuth; // Add all actions here

// Reducer
export type AuthContextState = { auth: IApiAuthResponse | null | undefined}
type Dispatch = (action: Action) => void;

function userReducer(state: AuthContextState, action: Action): AuthContextState {
    switch (action.type) {
        case 'setAuth':
            return {auth: action.payload}
        default:
            return state        
    }
}

// Context
const AuthContext = createContext<{ authDispatch: Dispatch } & AuthContextState | undefined>(undefined)

// Provider 
function AuthProvider({ children }: { children: React.ReactNode }) {
    const [state, dispatch] = useReducer(userReducer, {auth: initialState})
    
    const value = { ...state, authDispatch: dispatch }

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    )
}

// Hook to consume channel data
function useAuth() {
    const context = useContext(AuthContext)
    if (context === undefined) throw new Error('useAuth must be used within a AuthProvider')
    return context
}

export { AuthProvider, useAuth }